export type ValidatorValue = string | number | boolean;

export type VETColValidator<TData, TValue = ValidatorValue> = {
  validate: (value: TValue, data: TData[], row: number, col: number) => boolean;
  errorMessage: string;
};

export const VETEmptyValidator = {
  validate: (value: string) => {
    return value != null && value !== "";
  },
  errorMessage: "Verdien skal ikke være tom",
};

export const VETHexColorValidator: VETColValidator<any, string> = {
  validate: (value: string) => /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value),
  errorMessage: "Verdien må være en gyldig hex-farge (f.eks. #FF5733 eller #FFF)",
};

export const VETAllowEmptyValidator: VETColValidator<any, string> = {
  validate: (value: string) => value == null || value === "" || true,
  errorMessage: "",
};

export const VETPercentValidator: VETColValidator<any, number> = {
  validate: (value: number) => typeof value === "number" && value >= 0 && value <= 100,
  errorMessage: "Verdien må være et tall mellom 0 og 100",
};

export const VETEmptyAndNoDuplicatesValidator = <TData = any>(
  field: keyof TData & string,
): VETColValidator<TData, string> => ({
  validate: (value: string, data: TData[], row: number) => {
    if (value == null || value === "") return false;
    return !data.some((item, index) => index !== row && (item as any)[field] === value);
  },
  errorMessage: "Verdien skal ikke være tom og må være unik",
});
